module.exports = __webpack_public_path__ + "img/curbed_arrow.8c45c849.svg";